import { FC } from 'react';

import { BoxProps } from '@mui/material';

import { BOX_SHADOW } from 'src/constants';

import { Flex } from '../Flex';

export const Card: FC<BoxProps> = ({ children, ...rest }) => {
    return (
        <Flex
            border="1px solid #ffea99"
            borderRadius="16px"
            boxShadow={BOX_SHADOW}
            padding="24px"
            flexDirection="column"
            {...rest}
        >
            {children}
        </Flex>
    );
};
